import React, { useEffect, useReducer } from 'react';
import { FetchType } from '../../../../../../enums';
import { PagePath } from '../../../../../../navigation/navigation.enums';
import { useAppActions, useAppState } from '../../../../../../overmind';
import { useForm } from 'react-hook-form';
import * as store from '../freemium-manage-person-panels.store';
import { Button, EmailValidator, FieldController, LettersValidator, RequiredValidator, TextField } from '@keplerco/core';
import { IFreemiumManagePersonDetailsLayoutProps } from '../freemium-manage-person-panels.models';
import { SaveUserDto } from '../../../../../../models/view/employee';

export function FreemiumManagePersonDetailsLayout({ person, onSubmit }: IFreemiumManagePersonDetailsLayoutProps): JSX.Element {
  const actions = useAppActions();
  const { companyVariables } = useAppState();

  const [, dispatch] = useReducer(store.reducer, store.initialState);

  const { control, handleSubmit, reset } = useForm<any>({ mode: 'onBlur' });


  useEffect(() => {
    async function getData() {
      actions.startLoader({ path: PagePath.freemiumUserManagementPeople, type: FetchType.DialogFetching });
      if (!!person) {
        reset({
          firstName: person.firstName,
          lastName: person.lastName,
          email: person.email,
          jobTitle: person.jobTitle
        });
      }
      actions.stopLoader(PagePath.freemiumUserManagementPeople);
    }

    getData();
  }, [person]);

  return (
    <div className="card">
      <h4>User Details</h4>

      <form
        id="savePerson"
        onSubmit={handleSubmit(async values => {
          actions.startLoader({ path: PagePath.freemiumUserManagementPeople, type: FetchType.Sending });
          const request: SaveUserDto = {
            ...values,
            id: person?.id,
            jobTitle: values.jobTitle,
            learnerSlug: person?.learnerSlug,
            roleSlugs: values.roleSlugs?.length ? values.roleSlugs.split(',') : [],
            managerSlugs: values.managerSlugs?.length ? values.managerSlugs.split(',') : [],
            periodOfExperience: !!values.periodOfExperience ? parseInt(values.periodOfExperience) : values.periodOfExperience,
            countryId: !!values.countryId ? parseInt(values.countryId) : values.countryId,
            companySlug: companyVariables.slug!,
          };

          const response = await actions.freemiumSavePerson(request);

          if (!!response) {
            dispatch({ type: store.FreemiumManagePersonPermissionsActionTypes.SetPerson, payload: person });
            onSubmit(response);
          }

          actions.stopLoader(PagePath.freemiumUserManagementPeople);
        })}
      >
        <div className="row">
          <div className="column">
            <FieldController
              control={control}
              name="firstName"
              rules={new LettersValidator()}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label="First name"
                  type="text"
                  validation={{
                    dirty: fieldState.isDirty || !!fieldState.error,
                    invalid: fieldState.invalid,
                    message: fieldState.error?.message ?? 'Please enter a first name',
                  }}
                  responsive
                />
              )}
            />
          </div>

          <div className="column">
            <FieldController
              control={control}
              name="lastName"
              rules={new LettersValidator()}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label="Last name"
                  type="text"
                  validation={{
                    dirty: fieldState.isDirty || !!fieldState.error,
                    invalid: fieldState.invalid,
                    message: fieldState.error?.message ?? 'Please enter a last name',
                  }}
                  responsive
                />
              )}
            />
          </div>
        </div>

        <div className="row">
          <div className="column">
            <FieldController
              control={control}
              name="email"
              rules={new EmailValidator()}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label="Email"
                  type="email"
                  validation={{
                    dirty: fieldState.isDirty || !!fieldState.error,
                    invalid: fieldState.invalid,
                    message: fieldState.error?.message ?? 'Please enter an email',
                  }}
                  responsive
                />
              )}
            />
          </div>

          <div className="column">
            <FieldController
              control={control}
              name="jobTitle"
              rules={new RequiredValidator()}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label="Job title"
                  type="text"
                  validation={{
                    dirty: fieldState.isDirty || !!fieldState.error,
                    invalid: fieldState.invalid,
                    message: fieldState.error?.message ?? 'Please enter a job title',
                  }}
                  responsive
                />
              )}
            />
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
          <Button type="button">Submit</Button>
        </div>
      </form>
    </div>
  );
}
